import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import Button from "@mui/material/Button";
import Icon from "@mui/material/Icon";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionActions from "@mui/material/AccordionActions";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { cloneDeep } from "lodash";
import { dateToString } from "components/Shared/Formatters";

const primaryLabel = (designation) => {
  return ((designation.appraiserDesignationType ? designation.appraiserDesignationType.name : "") + " " + designation.status);
};

const blankDesignation = () => {
  return {
    id: 0,
    appraiserId: 0,
    appraiserDesignationTypeId: 0,
    designationCode: null,
    validFrom: null,
    validTo: null,
    status: "NEW",
    appraiserDesignationType: {
      id: 0,
      abbreviation: null,
      name: "New Item",
      code: null,
      description: null,
      requiresRenewal: true,
      renewalIntervalDays: 365
    }
  };
};

const secondaryLabel = (designation) => {
  return (designation.validFrom ? dateToString(designation.validFrom) + " - " : "") + (designation.validTo ? dateToString(designation.validTo) : "");
};

class RenderDesignations extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      designation: []
    };
    this.handleSave = this.handleSave.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.setState({ designation: this.props.fields });
  }

  handleSave() {
    this.props.saveDesignation(this.state.designation);
  }

  handleRemove(index) {
    let newDesignation = cloneDeep(this.state.designation);
    newDesignation[index].status = "REMOVE";
    this.props.saveDesignation(newDesignation);
  }

  render() {
    const { designation } = this.state;
    return (
      <div className="md-grid">
        <div className="md-cell md-cell--12 md-cell--right">
          {designation && designation.map((designation, index) => {
            let currentItem = designation;
            return (
              <Accordion className="md-cell md-cell--12 md-cell--right"
                key={index}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography>{primaryLabel(currentItem)}</Typography>
                  <Typography sx={{ color: 'text.secondary', ml: 1 }}>{secondaryLabel(currentItem)}</Typography>
                </AccordionSummary>
                <AccordionDetails className="md-grid">
                  <TextField
                    select
                    variant="standard"
                    id="select-field-1"
                    label="Designation Type"
                    className="md-cell md-cell--12 md-cell--right"
                    onChange={(e) => {
                      let newDesignation = cloneDeep(this.state.designation);
                      newDesignation[index].appraiserDesignationTypeId = e.target.value;
                      this.setState({ designation: newDesignation });
                    }}
                    value={this.state.designation[index].appraiserDesignationTypeId}
                  >
                    {this.props.designationList.map(x => (
                      <MenuItem key={x.id} value={x.id}>{x.name}</MenuItem>
                    ))}
                  </TextField>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    label="Valid From Date"
                    value={this.state.designation[index].validFrom ? new Date(this.state.designation[index].validFrom) : null}
                    onChange={(newValue) => {
                      let newDesignation = cloneDeep(this.state.designation);
                      newDesignation[index].validFrom = newValue;
                      this.setState({ designation: newDesignation });
                    }}
                    slotProps={{ textField: { variant: 'standard', className: 'md-cell md-cell--6' } }}
                  />
                  <DatePicker
                    label="Valid To Date"
                    value={this.state.designation[index].validTo ? new Date(this.state.designation[index].validTo) : null}
                    onChange={(newValue) => {
                      let newDesignation = cloneDeep(this.state.designation);
                      newDesignation[index].validTo = newValue;
                      this.setState({ designation: newDesignation });
                    }}
                    slotProps={{ textField: { variant: 'standard', className: 'md-cell md-cell--6 md-cell--right' } }}
                  />
                </LocalizationProvider>
                  <div className="md-cell md-cell--12 offset-md--4">
                    <i className="md-icon material-icons" onClick={() => this.handleRemove(index)} >delete</i>
                  </div>
                </AccordionDetails>
                <AccordionActions>
                  <Button variant="text" disabled={this.state.designation[index].appraiserDesignationTypeId === 0} onClick={this.handleSave}>Save</Button>
                </AccordionActions>
              </Accordion>);
          })}
        </div>
        <Button className="md-cell md-cell--12 md-cell--right"
          variant="text"
          color="secondary"
          startIcon={<Icon>add</Icon>}
          onClick={() => {
            let newDesignation = cloneDeep(this.state.designation);
            newDesignation.push(blankDesignation());
            this.setState({ designation: newDesignation });
          }}>Add Designation
        </Button>
      </div>
    );
  }
}

RenderDesignations.propTypes = {
  fields: PropTypes.array,
  designationList: PropTypes.array,
  saveDesignation: PropTypes.func
};

const mapStateToProps = state => {
  return {
    designationList: state.appraiser.designationList,
  };
};

export default connect(mapStateToProps)(RenderDesignations);